import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface SharingZoomState {
    scale: number;
    tx: number;
    ty: number;
}

const initialState: SharingZoomState = {
    scale: 1,
    tx: 0,
    ty: 0,
};

const sharingZoomSlice = createSlice({
    name: 'sharingZoom',
    initialState,
    reducers: {
        setSharingZoom(state, action: PayloadAction<SharingZoomState>) {
            state.scale = action.payload.scale;
            state.tx = action.payload.tx;
            state.ty = action.payload.ty;
        },
        resetSharingZoom() {
            return initialState;
        },
    },
});

export const { setSharingZoom, resetSharingZoom } = sharingZoomSlice.actions;
export const sharingZoomReducer = sharingZoomSlice.reducer;
